import React from 'react';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

/*\
 *  @params: Component is the component that is being prevented from nesting instances.
\*/
export default function preventNestedInstances(Component) {
  var PreventNestedInstancesContext = /*#__PURE__*/React.createContext(false);
  return function PreventNestedInstances(props) {
    return (
      /*#__PURE__*/
      // TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
      React.createElement(PreventNestedInstancesContext.Consumer, null, function (shouldPreventInstantiation) {
        return shouldPreventInstantiation ? props.children : /*#__PURE__*/React.createElement(PreventNestedInstancesContext.Provider, {
          value: true
        }, /*#__PURE__*/React.createElement(Component, props));
      })
    );
  };
}